@if (hasData())
{
<chartjs-container fxFlex="100" [config]="chartJsConfig">
</chartjs-container>
}
@else
{
<div class="noDataChartCriteria">Not enough data to display graph</div>
}
